import { PreloaderCircularProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const PreloaderCircular = (props: PreloaderCircularProps) => {
  const { variant = 'accent', size = 'medium' } = props;
  return <div role="preloader" {...stylex.props(styles[size], styles.base, styles[variant])}></div>;
};

export default PreloaderCircular;
